import { render, staticRenderFns } from "./core_list.vue?vue&type=template&id=c7071654"
import script from "./core_list.vue?vue&type=script&lang=js"
export * from "./core_list.vue?vue&type=script&lang=js"
import style0 from "./core_list.vue?vue&type=style&index=0&id=c7071654&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports